import {defineStore} from "pinia";

interface SubAppState {
  menuFlag: boolean;
}

export const useSubAppStore = defineStore('subAppStore', {
  state: (): SubAppState => ({
    menuFlag: true,
  }),
  getters: {
    getMenuFlag():any{
      return this.menuFlag;
    }
  },
  actions: {
    setMenuFlag(flag){
       return this.menuFlag=flag;
    }
  },
})
